import { render, staticRenderFns } from "./ProcessStory.vue?vue&type=template&id=764da9c2"
import script from "./ProcessStory.vue?vue&type=script&lang=js"
export * from "./ProcessStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports